interface Topic {
  tag: string;
  heat: string;
  icon: string;
  hot: boolean;
}

const topics: Topic[] = [
  { tag: '某顶流男星深夜密会神秘女子', heat: '982.3万', icon: 'ri-fire-line', hot: true },
  { tag: '知名女星婚变内幕连环曝光', heat: '876.5万', icon: 'ri-emotion-sad-line', hot: true },
  { tag: '综艺节目翻车现场全记录', heat: '754.2万', icon: 'ri-emotion-laugh-line', hot: false },
  { tag: '当红小生人设崩塌始末', heat: '689.7万', icon: 'ri-alert-line', hot: true },
  { tag: '选秀节目黑幕大起底', heat: '621.3万', icon: 'ri-spy-line', hot: false },
  { tag: '古装剧男主私生活混乱实锤', heat: '578.9万', icon: 'ri-user-unfollow-line', hot: false },
  { tag: '某女团成员恋情意外曝光', heat: '512.4万', icon: 'ri-heart-line', hot: false },
  { tag: '老牌歌手税务风波最新进展', heat: '467.8万', icon: 'ri-money-cny-circle-line', hot: false },
  { tag: '新生代演员学历造假疑云', heat: '398.6万', icon: 'ri-graduation-cap-line', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            全网最热的吃瓜话题实时追踪，热度数据每小时更新
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg ${
                topic.hot ? 'bg-primary-100 text-primary-600' : 'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${topic.icon} text-lg`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-700 transition-colors">
                  {topic.tag}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  {topic.hot && (
                    <span className="text-[10px] px-1.5 py-0.5 bg-primary-500 text-background-50 rounded font-semibold whitespace-nowrap">
                      HOT
                    </span>
                  )}
                  <span className="text-xs text-foreground-400">{topic.heat} 热度</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}